import {
    Card as MuiCard, 
    withStyles,
    Typography,
    Theme,
    Button as MuiButton
} from "@material-ui/core";

const Card = withStyles((theme: Theme) => ({
    root: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "60px",
        height: "100%",
        minWidth: "120px"
    }
}))(MuiCard);

const Button = withStyles((theme: Theme) => ({
    root: {
        padding: "12px 20px",
        width: "100%",
        height: "100%",
    }
}))(MuiButton);

type PropertyCardProps = {
    title: string;
    active?: boolean;
    onCardClick: Function;
};

const PropertyCard: React.FC<PropertyCardProps> = ({
    title,
    active,
    onCardClick
}) => (
    <Card style={{ background: active ? "linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%)" : "rgba(255, 255, 255, 0.05)"}}>
        <Button onClick={() => {onCardClick()}} style={{cursor: active ? "default" : "pointer"}}>
            <Typography style={{fontSize: "14px", color: active ? "#333333" : "inherit", fontWeight: active ? "bold" : "inherit"}} variant="h6">
                {title}
            </Typography>
        </Button>
    </Card>
)

export default PropertyCard;
